module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/th_okinawa-163720cd98e30f8fd9efb041e4ab49d8.jpg";